const LINK_REGEX = /(?:https?:\/\/|www\.)\S+/gi;
const TRAILING_PUNCTUATION = ['.', ',', '!', '?', ';', ':', "'", '"'];
const countOccurrences = (value, char) => value.split(char).length - 1;
const stripTrailingPunctuation = (link) => {
    let result = link;
    let stripped = true;
    while (stripped && result.length > 0) {
        stripped = false;
        const lastChar = result.charAt(result.length - 1);
        if (TRAILING_PUNCTUATION.includes(lastChar)) {
            result = result.slice(0, -1);
            stripped = true;
        }
        else if (lastChar === ')' &&
            countOccurrences(result, ')') > countOccurrences(result, '(')) {
            result = result.slice(0, -1);
            stripped = true;
        }
        else if (lastChar === ']' &&
            countOccurrences(result, ']') > countOccurrences(result, '[')) {
            result = result.slice(0, -1);
            stripped = true;
        }
    }
    return result;
};
export const cleanLinkText = (link) => link.replace(/^https?:\/\//i, '').replace(/\/$/, '');
export const splitTextByLinks = (text) => {
    const segments = [];
    let lastIndex = 0;
    for (const match of text.matchAll(LINK_REGEX)) {
        const url = stripTrailingPunctuation(match[0]);
        if (url) {
            const start = match.index ?? 0;
            if (start > lastIndex) {
                segments.push({ text: text.slice(lastIndex, start) });
            }
            segments.push({ text: url, url });
            lastIndex = start + url.length;
        }
    }
    if (lastIndex < text.length) {
        segments.push({ text: text.slice(lastIndex) });
    }
    return segments;
};
export const containsLink = (text) => splitTextByLinks(text).some((segment) => segment.url !== undefined);
